import Vue from 'vue';
import Toasted from 'vue-toasted';
import VueCookies from 'vue-cookies';
import VueSlider from 'vue-slider-component';
import { lowerCase } from 'lodash';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import App from './App';
import router from './router';
import store from './store';
import initializeFilters from './filters';
import './global-components';
import './libs';
import i18n from './i18n';

Vue.use(Toasted, {
  theme: 'toasted-custom',
  position: 'bottom-right',
  duration: 3000,
  containerClass: 'notification-bottom-right',
});
Vue.use(VueCookies);
Vue.component('VueSlider', VueSlider);

Vue.config.productionTip = false;

initializeFilters(Vue);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

Sentry.init({
  enabled: process.env.VUE_APP_SENTRY_ENABLED,
  environment: process.env.NODE_ENV,
  dsn: process.env.VUE_APP_SENTRY_URL,
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
});

Sentry.configureScope(scope => {
  scope.setLevel(lowerCase(process.env.VUE_APP_SENTRY_LEVEL));
});
